import { EuiButton, EuiSpacer } from '@elastic/eui';
import { Link } from 'gatsby';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Cloud/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemAlarmPerm';
import CloudTable from 'components/Web_User_Interface/1440p_Series/Cloud/CloudTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiButton,
  EuiSpacer,
  Link,
  SuccessBox,
  PermissionBox,
  CloudTable,
  BreadCrumbs,
  SEOHelmet,
  React
};